import { type InventoryAndContentState, InventoryContentOption } from '@openx/types/targeting/inventoryAndContent';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

import type { JSX } from 'react';

export type DrawerComponentsMap = Record<
  Exclude<keyof InventoryAndContentState, typeof InventoryContentOption.CONTENT_INTER_DIMENSION_OPERATOR>,
  JSX.Element
>;

export const filterTypes = (
  allTypes: DrawerComponentsMap,
  isBefInstance: boolean,
  customOptions?: {
    availableOptions: InventoryContentOption[];
  }
): Partial<DrawerComponentsMap> => {
  if (!isBefInstance) {
    const publisherTargeting = omit(allTypes, [
      InventoryContentOption.PUBLISHER_ID,
      InventoryContentOption.INSTANCE_HASH,
    ]);

    return publisherTargeting;
  }

  if (customOptions) {
    return pick(allTypes, customOptions.availableOptions);
  }

  return allTypes;
};
